import PropTypes from 'prop-types';

const LoginShield = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="426"
    height="355"
    viewBox="0 0 426 355"
    className={className}
  >
    <defs>
      <linearGradient id="a" x1="50%" x2="50%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="gray" stopOpacity=".25" />
        <stop offset="54%" stopColor="gray" stopOpacity=".12" />
        <stop offset="100%" stopColor="gray" stopOpacity=".1" />
      </linearGradient>
      <linearGradient id="b" x1="0%" y1="50.004%" y2="50.004%">
        <stop offset="0%" stopColor="gray" stopOpacity=".25" />
        <stop offset="54%" stopColor="gray" stopOpacity=".12" />
        <stop offset="100%" stopColor="gray" stopOpacity=".1" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#B0BEC5"
        d="M72 259h35v3H72zM84 303h35v3H84zM112 321h16v6h-16zM124 345h16v3h-16z"
      />
      <path
        fill="url(#a)"
        d="M137.95.025L.198 84.014s0 173.226 137.752 267.711C275.703 257.24 275.703 84.014 275.703 84.014L137.95.024z"
        opacity=".5"
        transform="translate(75)"
      />
      <path
        fill="#FFF"
        d="M212 5L80 86.914S80 255.86 212 348C344 255.845 344 86.914 344 86.914L212 5z"
      />
      <path
        fill="#6C63FF"
        d="M214.302 5L212 6.397V346.4c.764.533 1.528 1.07 2.302 1.599C349 255.853 349 86.912 349 86.912L214.302 5z"
        opacity=".04"
      />
      <path
        fill="url(#b)"
        d="M10.919 22.702l25.106 23.473L67.15.378 79.704 11.05l-43.68 56.465L.455 26.968z"
        opacity=".7"
        transform="translate(171 146)"
      />
      <path
        fill="#3AD29F"
        d="M186.502 171.802l20.398 19.483L235.801 147 246 155.86 206.9 209 178 175.343z"
      />
      <path
        fill="#FDA57D"
        d="M114.372 252s-24.347 2.625-16.985 16.287A148.243 148.243 0 0 1 108.572 296l12.878-2.498s-5.096-22.327-9.623-24.952L124 266.447 114.372 252z"
      />
      <path
        fill="#000"
        d="M109.995 268.55L121 266.447 112.296 252s-.257.03-.704.102l8.643 14.345-11.005 2.103c4.097 2.625 8.704 24.952 8.704 24.952L107 295.844l.043.156 11.642-2.498s-4.597-22.327-8.69-24.952z"
        opacity=".05"
      />
      <path
        fill="#6C63FF"
        d="M116.653 290.659s-7.391 5.069-18.607 4.663c0 0-5.965 2.594 2.476 4.66 8.44 2.064 22.06.607 23.13-.989 1.07-1.596-.445-6.985-2.936-9.194-2.491-2.208-4.063.86-4.063.86z"
      />
      <path
        fill="#FDA57D"
        d="M134.028 286.386s-.568 10.16 3.397 17.45L140.254 339h9.059s0-17.193 4.248-26.307c4.249-9.114-2.266-19.273-2.266-19.273l-.568-10.42-16.699 3.386z"
      />
      <ellipse cx="138" cy="173.5" fill="#FDA57D" rx="12" ry="10.5" />
      <path fill="#FDA57D" d="M131 181h12v12h-12z" />
      <path
        fill="#6C63FF"
        d="M143.026 337.049s-8.483 3.071-19.513.71c0 0-6.503 1.18 1.413 4.489 7.915 3.308 21.777 4.488 23.19 3.303 1.412-1.184 1.134-6.142-.846-8.502-1.98-2.36-4.244 0-4.244 0z"
      />
      <path
        fill="#FDA57D"
        d="M110.082 213l-16.224 41.222s-12.39 3.254-6.054 9.223c0 0-1.105-5.697 7.705-4.07 0 0 2.48 4.07 2.48 5.426 0 1.355 2.828-4.534 1.688-7.416a65.964 65.964 0 0 1 13.709-22.97s6.882-11.934 6.606-20.07l-9.91-1.345zM163.12 198.497s8.934 4.264 13.398 2.844c3.163-1.008 6.606-7.431 8.348-11.083a5.435 5.435 0 0 1 4.231-3.088c3.319-.406 7.97-.364 6.684 3.383-1.955 5.685-8.374 7.39-8.374 7.39L178.193 211H162l1.12-12.503z"
      />
      <circle cx="136" cy="174" r="12" fill="#3D213C" />
      <ellipse cx="142" cy="166" fill="#3D213C" rx="8" ry="5" />
      <path
        fill="#000"
        d="M134 288.876V290l16-1.718V287zM111.107 252l-1.107.195L115.332 266l.668-.106zM168 201l2.269.321L171 211h-3zM109.361 214l-.361.938 9.725 6.062.275-1.06zM121.572 248l-1.572.644s26.323 13.144 35 1.63l-.288-1.022s-7.977 11.013-33.14-1.252z"
        opacity=".05"
      />
      <path
        fill="#4D8AF0"
        d="M81.445 24.568a1.934 1.934 0 0 1-1.048-2.327c.021-.07.035-.142.042-.215a.964.964 0 0 0-1.735-.639.828.828 0 0 0-.105.189 1.93 1.93 0 0 1-2.328 1.074.781.781 0 0 0-.215-.042.965.965 0 0 0-.686 1.72.828.828 0 0 0 .188.104 1.928 1.928 0 0 1 1.075 2.327.975.975 0 0 0-.042.215.964.964 0 0 0 1.735.639.828.828 0 0 0 .105-.189 1.93 1.93 0 0 1 2.327-1.074c.07.021.142.035.215.042a.965.965 0 0 0 .64-1.735.828.828 0 0 0-.168-.089zM9.47 183.568a1.931 1.931 0 0 1-1.08-2.327c.022-.07.036-.142.042-.215a.964.964 0 0 0-.631-.966.971.971 0 0 0-1.111.327.827.827 0 0 0-.106.189 1.94 1.94 0 0 1-2.337 1.074.787.787 0 0 0-.215-.042.969.969 0 0 0-.968.617.962.962 0 0 0 .304 1.102.833.833 0 0 0 .19.105c.89.4 1.34 1.398 1.053 2.327a.971.971 0 0 0-.043.215c-.027.426.23.819.632.966a.971.971 0 0 0 1.11-.327.827.827 0 0 0 .106-.189 1.94 1.94 0 0 1 2.337-1.074c.07.021.143.035.216.042a.969.969 0 0 0 .971-.629.962.962 0 0 0-.329-1.106.832.832 0 0 0-.142-.089z"
        opacity=".5"
      />
      <circle cx="370" cy="127" r="3" fill="#F55F44" opacity=".5" />
      <circle cx="62" cy="339" r="3" fill="#F55F44" opacity=".5" />
      <circle cx="420" cy="241" r="3" fill="#F55F44" opacity=".5" />
      <path
        fill="#4D8AF0"
        d="M350.445 37.568a1.933 1.933 0 0 1-1.075-2.327c.021-.07.035-.142.042-.215a.964.964 0 0 0-1.736-.639.828.828 0 0 0-.105.189 1.93 1.93 0 0 1-2.328 1.074.782.782 0 0 0-.215-.042.965.965 0 0 0-.661 1.72.829.829 0 0 0 .189.104 1.928 1.928 0 0 1 1.075 2.327.974.974 0 0 0-.042.215.964.964 0 0 0 1.736.639.828.828 0 0 0 .104-.189 1.93 1.93 0 0 1 2.329-1.074c.07.021.142.035.215.042a.965.965 0 0 0 .64-1.735.829.829 0 0 0-.168-.089zM400.448 348.568a1.937 1.937 0 0 1-1.069-2.327c.021-.07.035-.142.042-.215a.964.964 0 0 0-.626-.966.957.957 0 0 0-1.1.327.83.83 0 0 0-.105.189 1.916 1.916 0 0 1-2.315 1.048.774.774 0 0 0-.214-.042.96.96 0 0 0-.999.618.967.967 0 0 0 .342 1.127c.058.043.121.078.188.105a1.932 1.932 0 0 1 1.069 2.327.979.979 0 0 0-.042.215.964.964 0 0 0 .626.966.957.957 0 0 0 1.1-.327.83.83 0 0 0 .105-.189 1.916 1.916 0 0 1 2.315-1.074c.07.021.141.035.214.042a.96.96 0 0 0 .962-.629.967.967 0 0 0-.326-1.106.823.823 0 0 0-.167-.089zM6.47 92.568a1.931 1.931 0 0 1-1.08-2.327c.022-.07.036-.142.042-.215a.964.964 0 0 0-.631-.966.971.971 0 0 0-1.111.327.827.827 0 0 0-.106.189 1.94 1.94 0 0 1-2.337 1.074.787.787 0 0 0-.215-.042.969.969 0 0 0-.968.617.962.962 0 0 0 .304 1.102.833.833 0 0 0 .19.105c.89.4 1.34 1.398 1.053 2.327a.971.971 0 0 0-.043.215c-.027.426.23.819.632.966a.971.971 0 0 0 1.11-.327.827.827 0 0 0 .106-.189 1.94 1.94 0 0 1 2.337-1.074c.07.021.143.035.216.042a.969.969 0 0 0 .971-.629.962.962 0 0 0-.329-1.106.832.832 0 0 0-.142-.089z"
        opacity=".5"
      />
      <circle cx="40" cy="140" r="3" fill="#47E6B1" opacity=".5" />
      <circle cx="423" cy="165" r="3" fill="#47E6B1" opacity=".5" />
      <g fill="#47E6B1" opacity=".5">
        <path d="M287.111 0h1.667v10h-1.667z" />
        <path d="M292.667 4.118v1.764h-9.445V4.118z" />
      </g>
      <g fill="#47E6B1" opacity=".5">
        <path d="M293.111 329h1.667v10h-1.667z" />
        <path d="M298.667 333.118v1.764h-9.445v-1.764z" />
      </g>
      <g fill="#47E6B1" opacity=".5">
        <path d="M11.111 345h1.667v10h-1.667z" />
        <path d="M16.667 349.118v1.764H7.222v-1.764z" />
      </g>
      <g fill="#47E6B1" opacity=".5">
        <path d="M352.111 196h1.667v10h-1.667z" />
        <path d="M357.667 200.118v1.764h-9.445v-1.764z" />
      </g>
      <path
        fill="#47E6B1"
        d="M393.252 62.002l2.998 3.14L400.5 58l1.5 1.432L396.25 68 392 62.572z"
        opacity=".5"
      />
      <path
        fill="#6C63FF"
        d="M108 249.366l7.445 20.894a153.892 153.892 0 0 1 10.83-3.04 18.343 18.343 0 0 1 5.614-.615c-1.489.269-1.256 1.232-1.667 2.688-.412 1.456-.288 2.995-.199 4.505a75.232 75.232 0 0 1-.615 15.202 120.887 120.887 0 0 1 23.973-2.629 74.264 74.264 0 0 1-2.224-13.013 14.977 14.977 0 0 1 0-3.464c.239-1.554.914-3.01 1.49-4.481a35.274 35.274 0 0 0 2.293-10.565 9.428 9.428 0 0 0-.452-4.129c-.705-1.735-2.278-3.015-4.015-3.767a19.578 19.578 0 0 0-5.515-1.261c-7.142-.87-14.14-.699-21.308-.63-2.75 0-4.095.864-6.572 2.037-.809.376-8.72 3.279-9.078 2.268z"
      />
      <path
        fill="#6C63FF"
        d="M122.77 191.476c-4.392 2.366-7.878 6.062-11.284 9.699L103 210.223a126.5 126.5 0 0 1 12.073 6.433c1.439.87 2.938 1.856 3.627 3.386.689 1.53.438 3.267.126 4.892a77.67 77.67 0 0 1-6.092 18.658c6.831 1.5 13.778 3 19.87 6.402 1.54.86 3.089 1.861 4.85 2.001a10.59 10.59 0 0 0 3.133-.375l15.454-3.451c.49-.067.954-.258 1.348-.556.276-.287.49-.627.628-1 2.722-5.922 5.509-12.13 5.217-18.638-.14-3.066-.96-6.177-.257-9.163.705-2.986 3.808-5.773 6.686-4.652l1.267-14.39c.146-1.622.177-3.502-1.096-4.543-.885-.71-2.118-.745-3.2-1.1-1.71-.56-3.018-1.921-4.527-2.901-4.12-2.686-9.442-2.366-14.352-1.946-4.175.355-8.315 1-12.465.4-4.492-.62-8.42-.41-12.52 1.796z"
      />
    </g>
  </svg>
);

LoginShield.propTypes = {
  className: PropTypes.string
};

export default LoginShield;
